// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"c51f5583","26":"d4ca2e62","32":"e1cdf315","160":"0d35f36b","225":"1609c7c6","353":"11cf828b","488":"7fca8102","565":"cd5add6b","574":"71dfca84","612":"0a381a21","664":"b402e825","675":"a5a4c114","755":"e5ea14ca","774":"e7a00b64","778":"a036a90f","932":"c21a7156"}[chunkId] + ".chunk.js";
};